import Component from '@glimmer/component';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import type Patient from 'parog-web/models/patient';
import BaseAntecedentsFields from '../base-antecedents-fields';
interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient: Patient;
  };
}

export default class MyComponent extends Component<Signature> {
  BaseAntecedentsFields = BaseAntecedentsFields;

  <template>
    <this.BaseAntecedentsFields @form={{@form}} @patient={{@patient}}>
      <div class='field'>
        <@form.AlignedFieldsRadioGroup
          @propertyName='familialPancreaticCancer'
          @title='Famille de cancer pancréatique familial'
          as |Group|
        >
          <Group.FieldRadio @label='Oui' @value={{true}} />
          <Group.FieldRadio @label='Non' @value={{false}} />
        </@form.AlignedFieldsRadioGroup>
      </div>

      <div class='field'>
        <@form.AlignedFieldsRadioGroup
          @propertyName='hereditaryChronicPrss1GeneMutation'
          @title='Pancréatite chronique héréditaire liée à mutation gène PRSS1'
          as |Group|
        >
          <Group.FieldRadio @label='Oui' @value={{true}} />
          <Group.FieldRadio @label='Non' @value={{false}} />
        </@form.AlignedFieldsRadioGroup>
      </div>
    </this.BaseAntecedentsFields>
  </template>
}
